import { CssVarsThemeOptions } from '@mui/material/styles'

// ----------------------------------------------------------------------

export function timeline(): CssVarsThemeOptions['components'] {
	return {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		MuiTimelineDot: {
			styleOverrides: {
				root: {
					boxShadow: 'none',
				},
			},
		},
		MuiTimelineConnector: {
			styleOverrides: {
				root: ({ theme }) => ({
					backgroundColor: theme.vars.palette.divider,
				}),
			},
		},
	}
}
